// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ctY9","col":"styles_col__3Plfk"};